// src/pages/ChartingV2/TreatmentPlan.page.tsx

import React from 'react'
import TreatmentPlanMain from '@components/pages/Charting/TreatmentPlan/TreatmentPlanMain.component'
import type { EmbeddedXraySelectedFile } from '@components/common/EmbeddedXrayViewer'
import type { TreatmentPlanNavigationHandle } from '@components/pages/Charting/TreatmentPlan/treatment-plan-navigation.types'

interface TreatmentPlanPageProps {
  onViewNote: (id: string) => void
  onAddTreatmentPlanRef?: React.MutableRefObject<(() => void) | null>
  onEmptyPlansChange?: (isEmpty: boolean) => void
  navigationRef?: React.MutableRefObject<TreatmentPlanNavigationHandle | null>
  isXrayPanelOpen: boolean
  initialEmbeddedFiles?: EmbeddedXraySelectedFile[] | null
  /** False while this tab is kept mounted but hidden (avoids a 0×0 OHIF viewport). */
  isHostVisible?: boolean
}

const TreatmentPlanPage = ({
  onViewNote,
  onAddTreatmentPlanRef,
  onEmptyPlansChange,
  navigationRef,
  isXrayPanelOpen,
  initialEmbeddedFiles,
  isHostVisible = true,
}: TreatmentPlanPageProps): React.ReactElement => {
  return (
    <TreatmentPlanMain
      onViewNote={onViewNote}
      onAddTreatmentPlanRef={onAddTreatmentPlanRef}
      onEmptyPlansChange={onEmptyPlansChange}
      navigationRef={navigationRef}
      isXrayPanelOpen={isXrayPanelOpen}
      initialEmbeddedFiles={initialEmbeddedFiles}
      isHostVisible={isHostVisible}
    />
  )
}

export default TreatmentPlanPage
